import React from "react";

export const Select = ({ children, ...props }) => {
  return (
    <select {...props} className="form-control">
      {children}
    </select>
  );
};
